import {Service} from "@/apiServices/Service";

export class ReportesService extends Service {
    constructor() {
        super('reportes/');
    }


    obtenerReciboPDF(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['recibo']), datos)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerReporteReembolsos(filtro) {
        this.onStart();
        return this.http.post(this.getUrl(['reembolsos']), filtro)
            .then(r => this.onData(r))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


}
